import { PitchCallPerScoringType } from '../enums/PitchCall.js';
import ScoringType from '../enums/ScoringType.js';

class PitchCallEnumSelector {
    constructor(strict, thrownOnError) {
        if (typeof(strict) === 'undefined') {
            strict = true;
        }
        if (typeof(thrownOnError) === 'undefined') {
            thrownOnError = true;
        }

        this.strict = !!strict;
        this.thrownOnError = !!thrownOnError;
    }

    select(scoringType) {
        if (typeof(scoringType) === 'undefined' || scoringType === null) {
            if (!this.strict) {
                // defaults to StatGrab
                scoringType = ScoringType.StatGrab.key;
            }
        }

        if (!PitchCallPerScoringType.hasOwnProperty(scoringType)) {
            if (this.thrownOnError) {
                throw new Error(`Unable to find matching PitchCall definition for given scoring type ${scoringType}`);
            }

            return;
        }

        return PitchCallPerScoringType[scoringType];
    }
}

export default PitchCallEnumSelector;